import { CacheManagerHydrationDataZOD, CacheManagerHydrationDataType } from 'src_server/models/cacheModels';

export const getSsrPreloadData = (): null | CacheManagerHydrationDataType => {
    // Document undefined if server side
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        return null;
    }
    try {
        const hydrationData = document.documentElement.getAttribute('data-hydration');

        if (hydrationData === null) {
            console.info('No hydration data found');
            return null;
        }

        const parsedDataToJs = JSON.parse(hydrationData);
        const parsedDataToModel = CacheManagerHydrationDataZOD.safeParse(parsedDataToJs);
        if (parsedDataToModel.success === false) {
            console.error('Failed to parse hydration data', parsedDataToModel.error);
            return null;
        }

        return parsedDataToModel.data;
    } catch (e) {
        console.error('Failed to get preload data', e);
    }
    return null;
};
